module.exports = __webpack_public_path__ + "img/logo-j2p.c69bd886.png";